(function () {
  function allowNativeBrowserAction(event) {
    event.stopImmediatePropagation();
  }

  ['contextmenu', 'copy', 'cut', 'paste', 'selectstart'].forEach(function (eventName) {
    window.addEventListener(eventName, allowNativeBrowserAction, true);
  });

  window.addEventListener('keydown', function (event) {
    if (!(event.ctrlKey || event.metaKey)) return;

    var key = String(event.key || '').toLowerCase();
    if (['a', 'c', 'x', 'v'].includes(key)) {
      event.stopImmediatePropagation();
    }
  }, true);
})();
